<script>
    import { createEventDispatcher } from 'svelte';
    import Modal from './Modal.svelte';
    import Button from './Button.svelte';
    import { page } from '$app/stores';
    import H2 from './H2.svelte';
    import H3 from './H3.svelte';

    export let shown = false;

    $: session = $page.data.session;

    const dispatch = createEventDispatcher();

    let feedback = '';
    let email = '';
    let loading = false;
    let error = '';
    let success = false;

    function handleClose() {
        if (!loading) {
            dispatch('close');
            resetForm();
        }
    }

    function resetForm() {
        feedback = '';
        email = '';
        error = '';
        success = false;
        loading = false;
    }

    async function handleSubmit() {
        if (!feedback.trim()) {
            error = 'Please enter your feedback';
            return;
        }

        loading = true;
        error = '';

        try {
            const formData = new FormData();
            formData.append('feedback', feedback.trim());
            formData.append('page_url', $page.url.href);
            formData.append('user_agent', navigator.userAgent);

            if (!session) {
                formData.append('email', email.trim());
            } else {
                formData.append('user_id', session.user.id);
            }

            const response = await fetch('/api/feedback', {
                method: 'POST',
                body: formData
            });

            const result = await response.json();

            if (!response.ok) {
                throw new Error(result.message || 'Failed to submit feedback');
            }

            success = true;

        } catch (err) {
            error =
                err.message || 'Failed to submit feedback. Please try again.';
        } finally {
            loading = false;
        }
    }
</script>

{#if shown}
    <Modal on:close={handleClose} sm>
        {#if success}
            <div class="text-center py-8 space-y-2">
                <H3 invert>
                    Thanks for your feedback!
                </H3>
                <p>We've received your message and will review it soon.</p>
            </div>
        {:else}
            <form id="feedback-form" on:submit|preventDefault={handleSubmit}>
                <div class="space-y-2">
                    <textarea
                        id="feedback-message"
                        bind:value={feedback}
                        class="h-fit"
                        disabled={loading}
                        rows="4"
                        placeholder="Have an idea, question, or comment?"
                        required
                    />
                    

                    {#if !session}
                        <input
                            id="feedback-email"
                            type="email"
                            bind:value={email}
                            disabled={loading}
                            placeholder="your@email.com, optional"
                        />
                    {/if}

                    <input
                        type="text"
                        name="username"
                        style="display: none;"
                        tabindex="-1"
                        autocomplete="off"
                    />

                    {#if error}
                        <div
                            class="text-red-600 text-sm bg-red-50 border border-red-200 rounded-lg p-3"
                        >
                            {error}
                        </div>
                    {/if}
                </div>
            </form>
        {/if}

        <div slot="footer" class="flex gap-3 justify-start flex-row-reverse">
            {#if !success}
                <Button
                    invert
                    submit
                    disabled={loading || !feedback.trim()}
                    {loading}
                    primary
                    on:click={handleSubmit}
                >
                    Send Feedback
                </Button>
                <Button invert on:click={handleClose} disabled={loading}>
                    Cancel
                </Button>
            {:else}
                <Button invert outline block on:click={handleClose}>Close</Button>
            {/if}
        </div>
    </Modal>
{/if}
